<img
  class="w-full rounded-full object-cover"
  [src]="src ?? defaultAvatar"
  alt=""
  style="aspect-ratio: 1 / 1"
/>
